"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoOpAi = void 0;
const core_1 = require("../../core/actions/core");
const Registries_1 = require("../../core/state/Registries");
let NoOpAi = class NoOpAi {
    init(sequence, container, state) { }
    handleEvent(sequence, container, state, e) { }
    nextTurn(sequence, container, state) {
        container.dispatch(sequence, state.selfId, new core_1.DoNothingActionArgs());
    }
};
NoOpAi = __decorate([
    Registries_1.Ai.register("NoOp")
], NoOpAi);
exports.NoOpAi = NoOpAi;
